module.exports = __webpack_public_path__ + "img/py_list_yasf_seleted.png.0f227bec.png";